module.exports = __webpack_public_path__ + "img/azxy10_icon.c19d9e5d.png";